import { Box, Tooltip, Typography } from "@mui/material";
import BlockGutterMap from "./BlockGutterMap";
import useIsMobile from "components/hooks/useIsMobile";
import { BlockGutterNoBorder } from "./BlockGutter";
import { StageChip } from "../workflowStates";
import { absoluteTime } from "common/utils";

export default ({
  accountType,
  transitionerName,
  stage,
  stageDate,
  transitionTime,
}: {
  accountType: "advisor" | "member";
  transitionerName: string;
  stage: string;
  transitionTime: Date;
  stageDate: string;
}) => {
  const isMobile = useIsMobile();
  return (
    <Box sx={{ display: "flex", gap: isMobile ? "12px" : "16px" }}>
      <BlockGutterNoBorder
        icon={BlockGutterMap.StageTransition.icon}
        isLast={false}
      />
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexWrap: "wrap",
          flexDirection: "row",
          alignItems: "center",
          gap: "4px",
          // Makes it appear center aligned with the gutter icon
          marginBottom: "8px",
        }}
      >
        <Tooltip title={absoluteTime(transitionTime)}>
          <>
            <Typography variant="bodyHeavy">
              <b>{transitionerName}</b>
            </Typography>
            <Typography variant="body" color="tertiary">
              updated status to
            </Typography>
          </>
        </Tooltip>
        <StageChip
          stage={stage}
          accountType={accountType}
          stageDate={stageDate}
        />
      </Box>
    </Box>
  );
};
